export default "__VITE_ASSET__63ec7b52__"